import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-12 relative z-10" aria-label="精选爆料">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {featured.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
          >
            <div className="relative h-44 overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  精选爆料
                </span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200 mb-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-100">
                <span className="text-xs text-foreground-400">{article.publishDate}</span>
                <span className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  {article.readCount > 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}